module.exports = __webpack_public_path__ + "img/paws.157b58a3.svg";